import { useHits, UseHitsProps } from "react-instantsearch"

import { DocumentData } from "../../utils/types"

export default function List(props: UseHitsProps<DocumentData>) {
  const { items } = useHits(props)

  /* No results */
  if (items.length === 0) return <p className="opacity-70">No results found</p>

  /* Results found */
  return (
    <ul className="flex flex-col gap-y-24 desktop:gap-y-36">
      {items.map((item: DocumentData) => {
        const {
          heading,
          // description,
          path,
          image,
          announcement_type,
          publication_name,
          publication_date,
        } = item
        return (
          <li key={path} className="border-b border-black-30">
            <a
              href={path}
              className="group flex flex-col tablet:flex-row tablet:gap-24"
            >
              <div className="flex-1 tablet:mb-24">
                <div className="flex items-center gap-x-16 text-14 mb-10">
                  <p className="text-purple font-bold">{announcement_type}</p>
                  {publication_date && (
                    <p>
                      {new Date(publication_date * 1000).toLocaleDateString(
                        undefined,
                        { year: "numeric", month: "long", day: "numeric" }
                      )}
                    </p>
                  )}
                  {publication_name && (
                    <p className="text-black-70">{publication_name}</p>
                  )}
                </div>

                {heading && (
                  <h3 className="inline-block group-hover:underline mb-24 desktop:mb-0">
                    {heading}
                    <span
                      aria-hidden="true"
                      className="inline-block transition-transform duration-100 motion-safe:group-hover:translate-x-6"
                    >
                      &nbsp;→{" "}
                    </span>
                  </h3>
                )}
              </div>

              {image && (
                <div className="tablet:max-w-[200px] aspect-[2/1] mb-24 tablet:mb-0">
                  <img
                    className="h-full w-full object-cover"
                    src={image.url}
                    alt={image.alt || ""}
                  />
                </div>
              )}
            </a>
          </li>
        )
      })}
    </ul>
  )
}
